import { Body, Card, CardContent } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';
import { useMitarbeiterabgleich } from '../../hooks/useMitarbeiterabgleich/useMitarbeiterabgleich';
import { AbgleichFilterLeiste } from './AbgleichFilterLeiste';
import { AbgleichKopf } from './AbgleichKopf';
import { AbgleichTabelle } from './AbgleichTabelle';
import { UebernehmenSpalte } from './UebernehmenSpalte';
import { useAbgleichAuswahl } from './useAbgleichAuswahl';

export function MitarbeiterAbgleichCard() {
  const { t } = useTranslation();
  const { zeilen, zusammenfassung, error, starteAbgleich } =
    useMitarbeiterabgleich();
  const auswahl = useAbgleichAuswahl(zeilen);

  if (!zusammenfassung) {
    return (
      <Card>
        <CardContent>
          <Body>{error ?? t('domain.datev.abgleich.ladefehler')}</Body>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent className="flex flex-col gap-6">
        <AbgleichKopf
          zusammenfassung={zusammenfassung}
          abweichungen={zeilen.length}
          onAbrufStarten={starteAbgleich}
        />
        <AbgleichFilterLeiste anzahl={zeilen.length} />

        <div className="overflow-x-auto">
          <div className="grid min-w-[1000px] grid-cols-[1fr_78px_1fr]">
            <AbgleichTabelle
              titel="e2n"
              quelle="e2n"
              zeilen={zeilen}
              auswahl={auswahl}
            />
            <UebernehmenSpalte zeilen={zeilen} />
            <AbgleichTabelle titel="DATEV" quelle="datev" zeilen={zeilen} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
